(function() {
    'use strict';
    angular
        .module('emarket.main.home')
        .controller('HomeController', ['$scope', '$q', '$interval', '$log', '$stateParams', '$mdDialog', 'Post', 'PremiumPost', function($scope,
            $q,
            $interval,
            $log,
            $stateParams,
            $mdDialog,
            Post,
            PremiumPost) {
            var vm = this;
            vm.products = [];
            vm.loaders = {
                premiums: true,
                last: true
            };
            vm.premiums = {};
            var promises = [];
            var suffleArray = function(a) {
                var j, x, i;
                for (i = a.length - 1; i > 0; i--) {
                    j = Math.floor(Math.random() * (i + 1));
                    x = a[i];
                    a[i] = a[j];
                    a[j] = x;
                }
                return a;
            };
            function showWelcomeDialog() {
                $mdDialog.show({
                    templateUrl: 'main/home/welcome.tpl.html',
                    controller: 'WelcomeDialogController as vm'
                });
            }
            if ($stateParams.bienvenido) {
                showWelcomeDialog();
            }
            promises.push(PremiumPost.getFrontPage().then(function(premiums) {
                var frontWithPost = premiums.front.filter(function(post) {
                    return post._id;
                });
                var frontAvailable = premiums.front.filter(function(post) {
                    return !post._id;
                });
                premiums.front = suffleArray(frontWithPost).concat(frontAvailable);
                vm.premiums = premiums;
                vm.loaders.premiums = false;
                return premiums;
            }));
            promises.push(Post.getLatest().then(function(post) {
                // vm.loaders.last = false;
                // vm.products = post;
                return post;
            }));
            // 5a703a8fb2770c8706672419
            // 5ad7a2ad8cd04b54f9f49868

            // promises.push(Post.$find('5bc8f1e774ce2d09ac3ef0e6')
            //     .$asPromise()
            //     .catch(function() {
            //         return null;
            //     }));
            // promises.push(Post.$find('5ac3c171a8f325d076b09e60')
            //     .$asPromise()
            //     .catch(function() {
            //         return null;
            //     }));
            // promises.push(Post.$find('5af0f102c36a7be89a08473a')
            //     .$asPromise()
            //     .catch(function() {
            //         return null;
            //     }));
            $q
                .all(promises)
                .then(function(response) {
                    var premiums = response[0];
                    var posts = response[1];
                    var post = response[2];
                    var post2 = response[3];
                    var post3 = response[4];
                    if (post) {
                        posts.categories = posts.categories.map(function(bulk) {
                            if (bulk.category.slug === 'video-juegos') {
                                bulk.posts.splice(-1, 1);
                                bulk.posts.unshift(post);
                            }
                            return bulk;
                        });
                    }
                    if (post2) {
                        posts.categories = posts.categories.map(function(bulk) {
                            if (bulk.category.slug === 'bienes-raices') {
                                bulk.posts.splice(-1, 1);
                                bulk.posts.unshift(post2);
                            }
                            return bulk;
                        });
                    }
                    if (post3) {
                        posts.categories = posts.categories.map(function(bulk) {
                            if (bulk.category.slug === 'computadoras-laptops-tabletas') {
                                bulk.posts.splice(-1, 1);
                                bulk.posts.unshift(post3);
                            }
                            return bulk;
                        });
                    }
                    vm.loaders.last = false;
                    vm.products = posts;
                    var latestAmount = 4 - premiums.latest.length;
                    premiums.latest = premiums.latest.concat(posts.latest.slice(0, latestAmount));
                })
                .catch(function() {
                    vm.loaders.latest = false;
                    vm.loaders.premiums = false;
                    $log.info('error');
                });

            vm.showAllPremiums = function() {
                $mdDialog.show({
                    templateUrl: 'main/home/all-offer-premium.tpl.html',
                    locals: {
                        posts: vm.premiums.front
                    },
                    controllerAs: 'vm',
                    controller: [
                        '$mdDialog',
                        '$scope',
                        'posts',
                        function($mdDialog, $scope, posts) {
                            var vm = this;
                            vm.hide = function() {
                                $mdDialog.hide();
                            };
                            vm.posts = posts;
                        }
                    ]
                });
            };
            var clearInterval = $interval(function() {
                vm.startAt = vm.startAt === 0 ? 4 : 0;
            }, 10000);
            $scope.$on('$destroy', function() {
                $interval.cancel(clearInterval);
            });
        }]);
}());
